import { render, staticRenderFns } from "./Seguro.vue?vue&type=template&id=a0796f92&"
import script from "./Seguro.vue?vue&type=script&lang=js&"
export * from "./Seguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports